import React from "react";
import NamedResourceForm from "../../curriculum/components/named-resource-form";
import {cvBenefitService} from "../../../services/curriculum-resource-service";

const CvBenefitForm = () => (
    <NamedResourceForm singularTitle="Benefício" article="o" basePath="/cv/benefit"
                       queryKey="cv-benefits" service={cvBenefitService}/>
);

export default CvBenefitForm;
